import React from 'react';
import './sec6.css'
import Pickevent from '../components/common/Pickevent';
import Bookcard from '../components/common/bookform';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Sec6 = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

 const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec6');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);



    return ( 
        <section className={`sec6 ${animate ? 'animate' : ''}`}  dir={direction}>
            <article className='main-card-sec6'>
                    <h1 className='header-sec6'> {t('Book Your Ticket')}</h1>
                    <article className={`container-forms ${animate ? 'animate' : ''}`}>
                        <Pickevent />
                        <Bookcard />
                    </article>
            </article>
        </section>
     );
}
 
export default Sec6;